import { jobMutateChargesInitialState } from "../mutate-charges/mutate-charges.state";
import { jobMutateDiscountsInitialState } from "../mutate-discount/mutate-discount.state";

export const jobMutatorsInitialState = {
  charge: jobMutateChargesInitialState,
  discount: jobMutateDiscountsInitialState,
} as const;

export const jobMutateObjectInitialState = {
  mutateObjectDialog: {
    mutators: jobMutatorsInitialState,
    mutateType: 'update' as 'update' | 'create',
    footerButtons: 'navigate' as 'navigate' | 'review' | 'mutate',
    activeStep: undefined as string | undefined,
    activeMutator: undefined as undefined | keyof (typeof jobMutatorsInitialState),
    loading: false as boolean,
  },
} as const;

export type MutateObjectState = typeof jobMutateObjectInitialState;
